import { currentUserQuery } from "@common/api"
import type { UserPublicMe } from "@common/client"
import { hasPermission, hasRolePermission } from "@common/lib/permissions"
import { useQuery } from "@tanstack/react-query"

export function useCurrentUser(): UserPublicMe | undefined {
  return useQuery(currentUserQuery()).data
}

export function useHasPermission(permission: string): boolean {
  return hasPermission(useCurrentUser(), permission)
}

export function useHasRolePermission(permission: string): boolean {
  return hasRolePermission(useCurrentUser(), permission)
}
